window.shareThis = function(selectedObject) {
    var itemType = $(selectedObject).find('a').attr('data-type');
    var itemUrl = $(selectedObject).find('a').attr('href');
    var metaTitle = $('meta[name=title]').attr('content');
    var dataString;

    switch (itemType) {
        case 'facebook':
            dataString =
                itemUrl +
                '+encodeURIComponent(' +
                metaTitle +
                ') +&u=' +
                window.location.href;
            window.open(
                dataString,
                'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'
            );
            break;
        case 'twitter':
            dataString = itemUrl + metaTitle + '&url=' + window.location.href;
            window.open(
                dataString,
                'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'
            );
            break;
        case 'YouTube':
            dataString = itemUrl;
            window.open(
                dataString,
                'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'
            );
            break;
    }
};
